export default function Card72(){
    return(
        <div>
            {/*<div className={"text-4xl p-8 bg-gradient-to-r from-indigo-200 via-purple-200 to-pink-200"}>*/}
            {/*    <div className={"text-center font-bold"}>Card 72 :</div>*/}
            {/*</div>*/}
            <div class="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
                <div class="mx-auto max-w-2xl mb-8 lg:mb-14 text-center">
                    <h2 class="text-3xl lg:text-4xl text-gray-800 font-bold dark:text-gray-200">
                        Explore tools
                    </h2>
                    <p class="mt-3 text-gray-800 dark:text-gray-200">
                        The powerful and flexible theme for all kinds of businesses.
                    </p>
                </div>
                
                <div class="mx-auto max-w-3xl grid grid-cols-12 gap-6 lg:gap-8">
                    <div class="col-span-6 sm:col-span-4 text-center">
                        <svg class="mx-auto h-auto w-7 md:w-9 text-gray-800 dark:text-gray-200" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="10" height="14" x="3" y="8" rx="2"/><path d="M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4"/><path d="M8 18h.01"/></svg>
                        <div class="mt-2 sm:mt-6">
                            <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-200">
                                Responsive
                            </h3>
                        </div>
                    </div>
                    
                    <div class="col-span-6 sm:col-span-4 text-center">
                        <svg class="mx-auto h-auto w-7 md:w-9 text-gray-800 dark:text-gray-200" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 7h-9"/><path d="M14 17H5"/><circle cx="17" cy="17" r="3"/><circle cx="7" cy="7" r="3"/></svg>
                        <div class="mt-2 sm:mt-6">
                            <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-200">
                                Customizable
                            </h3>
                        </div>
                    </div>
                    
                    <div class="col-span-6 col-start-4 sm:col-span-4 text-center">
                        <svg class="mx-auto h-auto w-7 md:w-9 text-gray-800 dark:text-gray-200" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5Z"/><path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1"/></svg>
                        <div class="mt-2 sm:mt-6">
                            <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-200">
                                24/7 Support
                            </h3>
                        </div>
                    </div>
                </div>
                
                <div class="mt-20 grid grid-cols-12 items-center gap-x-2 sm:gap-x-6 lg:gap-x-8">
                    <div class="hidden md:block col-span-4 md:col-span-3">
                        <img class="rounded-xl opacity-50 w-full" src="https://dummyimage.com/230x170" alt="Description"/>
                    </div>

                    <div class="col-span-4 md:col-span-3">
                        <img class="rounded-xl opacity-50 w-full" src="https://dummyimage.com/270x340" alt="Description"/>
                    </div>

                    <div class="col-span-4 md:col-span-3">
                        <img class="rounded-xl opacity-50 w-full" src="https://dummyimage.com/270x490" alt="Description"/>
                    </div>

                    <div class="col-span-4 md:col-span-3">
                        <img class="rounded-xl opacity-50 w-full" src="https://dummyimage.com/230x170" alt="Description"/>
                    </div>
                </div>
            </div>
        </div>
    )
}